import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Fuse from 'fuse.js';
import _ from 'lodash';
import { Input, InputAdornment } from '@material-ui/core';
import { MdSearch } from 'react-icons/lib/md';

class SearchBar extends React.Component {
  static propTypes = {
    data: PropTypes.arrayOf(PropTypes.object),
    onChange: PropTypes.func,
  };

  static defaultProps = {
    data: [],
    onChange: () => {},
  };

  state = {
    search: '',
  };

  componentDidMount() {
    const filteredData = this.getFilteredData();
    this.props.onChange(filteredData);
  }

  componentDidUpdate(prevProps) {
    if (!_.isEqual(prevProps.data, this.props.data)) {
      const filteredData = this.getFilteredData();
      this.props.onChange(filteredData);
    }
  }

  getFilteredData = () => {
    const options = {
      shouldSort: true,
      threshold: 0.4,
      location: 0,
      distance: 100,
      maxPatternLength: 32,
      minMatchCharLength: 1,
      keys: ['name', 'fullName', 'candidateID'],
    };

    const fuse = new Fuse(this.props.data, options);

    if (this.state.search !== '') {
      return fuse.search(this.state.search);
    }

    return this.props.data;
  };

  handleSearchbarInputChange = (event) => {
    this.setState({ search: event.target.value }, () => {
      const filteredData = this.getFilteredData();
      this.props.onChange(filteredData);
    });
  };

  render() {
    return (
      <StyledInput
        id="search-bar"
        placeholder="Search"
        value={this.state.search}
        startAdornment={(
          <InputAdornment position="start">
            <MdSearch size={24} />
          </InputAdornment>
)}
        onChange={this.handleSearchbarInputChange}
      />
    );
  }
}

export default SearchBar;

const StyledInput = styled(Input)`
  && {
    height: 48px;
    align-items: center;
  }
`;



// WEBPACK FOOTER //
// ./src/components/SearchBar/SearchBar.js